export default __webpack_public_path__ + "weapon-picked-4535dc785b3cbdf5057099b1a3b8130a.mp3";